<template>
  <div class="highchart-container">
    <highcharts
      :options="chartOptions"
    />
  </div>
</template>

<script>
import moment from 'moment';
import unitPreferencesMixin from '@shared/mixins/unitPreferencesMixin';

import convertToCelsius from '@shared/lib/converter/convertToCelsius';

export default {
  name: 'DailySupplyAirGraph',
  mixins: [unitPreferencesMixin],
  props: {
    dailyStats: Array,
  },
  computed: {
    graphData() {
      const {
        partnerSettings: {
          TEMP_UNIT = '°F',
          DATE_FORMAT = 'MM-DD-YYYY',
        }
      } = this.$store.state.admin;

      const {
        tempFormat,
      } = this;
      const columnDate = [];
      const supplyAirAvgTemp = [];
      const maxOATemp = [];
      const minOATemp = [];

      this.dailyStats.forEach((c) => {
        const {
          localDate,
          sensorDailystats,
          maxTempAPI,
          minTempAPI,
        } = c;

        if (sensorDailystats && sensorDailystats.length) {
          const supplyAir = sensorDailystats.find(s => s.label === 'Supply Air');

          if (supplyAir?.avgTemp) {
            const {
              avgTemp,
            } = supplyAir;
            let temp = avgTemp;
            if (TEMP_UNIT === '°C') {
              temp = convertToCelsius(temp);
            }
            supplyAirAvgTemp.push(temp);
          }
        } else {
          supplyAirAvgTemp.push(null);
        }

        let max = maxTempAPI;
        if (TEMP_UNIT === '°C') {
          max = convertToCelsius(max);
        }
        let min = minTempAPI;
        if (TEMP_UNIT === '°C') {
          min = convertToCelsius(min);
        }

        let date = moment(localDate).format('M/D/YYYY');
        if (DATE_FORMAT === 'DD-MM-YYYY') {
          date = moment(localDate).format('D/M/YYYY');
        }
        maxOATemp.push(max);
        minOATemp.push(min);
        columnDate.push(date);
      });

      return {
        columnDate,
        supplyAirAvgTemp,
        minOATemp,
        maxOATemp,
      };
    },
    chartOptions() {
      const {
        tempFormat,
      } = this;

      const {
        columnDate,
        supplyAirAvgTemp,
        minOATemp,
        maxOATemp,
      } = this.graphData;

      return {
        chart: {
          zoomType: 'x',
          height: 400,
          backgroundColor: '#0f1734',
        },
        credits: {
          enabled: false,
        },
        title: {
          text: 'Supply Air',
          style: {
            color: 'white',
          },
        },
        tooltip: {
          useHTML: true,
          nullFormat: 'Value is not available.',
          formatter() {
            return `${this.x}<br/>`
              + `${this.series.name}: <b>${this.y}</b>`;
          },
        },
        xAxis: [{
          categories: columnDate,
          reversed: new Date(columnDate[0]) > new Date(columnDate[columnDate.length - 1]),
          title: {
            text: 'Days',
            style: {
              color: 'white',
            },
          },
          labels: {
            style: {
              color: 'white',
            },
          },
        }],
        yAxis: [{
          labels: {
            format: `{value}${tempFormat}`,
            style: {
              color: 'white',
            },
          },
          title: {
            text: 'Supply Temperature',
            style: {
              color: 'white',
            },
          },
          min: Math.min(...supplyAirAvgTemp) - 4,
          max: Math.max(...supplyAirAvgTemp) + 4,
          opposite: false,
        },
        {
          labels: {
            format: `{value}${tempFormat}`,
            style: {
              color: 'white',
            },
          },
          title: {
            text: 'Outside Air Temperature',
            style: {
              color: 'white',
            },
          },
          min: Math.min(...minOATemp, ...maxOATemp) - 4,
          max: Math.max(...minOATemp, ...maxOATemp) + 4,
          opposite: true,
        }],
        legend: {
          itemStyle: {
            color: 'white',
          },
          shadow: false,
          align: 'center',
          verticalAlign: 'bottom',
          x: 0,
          y: 0,
        },
        series: [{
          type: 'line',
          yAxis: 0,
          xAxis: 0,
          name: 'Avg Temp',
          color: '#4CD87D',
          data: supplyAirAvgTemp,
        }, {
          type: 'scatter',
          yAxis: 1,
          xAxis: 0,
          name: 'Max OA T',
          color: '#ffa500',
          data: maxOATemp,
        }, {
          type: 'scatter',
          yAxis: 1,
          xAxis: 0,
          name: 'Min OA T',
          color: '#ffdb9a',
          data: minOATemp,
        }],
      };
    },
  },
};
</script>
